<template>
  <div class="sys ql-editor">
    <bcc-breadcrumb style="margin-left: 26px;">
      <bcc-breadcrumb-item :to="{ name: 'home' }" @click.native="$LogReport.sendCustomEvent('openplat_notice_backto_home')">首页</bcc-breadcrumb-item>
      <bcc-breadcrumb-item :to="{ name: 'sys' }" @click.native="$LogReport.sendCustomEvent('openplat_notice_backto_notices')">系统公告</bcc-breadcrumb-item>
    </bcc-breadcrumb>
    <h1 class="sys-title" style="margin-left: 26px;">公告详情</h1>
    <div v-if="detail" class="sys-wrapper">
      <div class="sys-body">
        <h2 class="sys-body-title">{{detail.title || '未知标题'}}</h2>
        <div class="sys-body-time">{{ detail.time }}</div>
        <div class="sys-body-content" v-html='detail.msg'></div>
        <div class="sys-body-signature">{{ detail.signature || ''}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sysDetail',
  data() {
    return {
      detail: null,
      noticeInfo: null,
    }
  },
  mounted() {
    this.getNotice().then(() => {
      const { sys_id } = this.$route.params
      this.$LogReport.sendCustomEvent('openplat_notice_load', {sys_id})
      if (
        this.noticeInfo &&
        this.noticeInfo.list &&
        this.noticeInfo.list[sys_id]
      ) {
        this.detail = this.noticeInfo.list[sys_id]
      }
    })
  },
  methods: {
    enterList() {
      this.$router.push({ name: 'sys' })
    },
    async getNotice() {
      const { ps, pn } = this.$route.params
      await this.$api.sys
        .noticeList({ps, pn})
        .then((data) => {
          this.noticeInfo = data
        })
        .catch((e) => {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '//s1.hdslb.com/bfs/templar/york-static/Fkn2zU3RV0KnA9r5.css';
.sys {
  padding: 32px 28px;
  max-width: 1168px;
  margin: 0 auto;
  &-list {
    border: 1px solid #e7e7e7;
    border-bottom: 0px;
    margin-top: 38px;
    &-item {
      background: #ffffff;
      box-shadow: inset 0 -1px 0 0 #e7e7e7;
      font-size: 16px;
      color: #212121;
      line-height: 16px;
      padding: 24px 18px 34px;
      cursor: pointer;
      &-text {
        font-size: 16px;
        color: #999999;
        line-height: 16px;
        margin-right: 34px;
      }
      &-icon {
        float: right;
        img {
          width: 20px;
          height: 20px;
        }
      }
      &:hover {
        background: #f4f4f4;
      }
    }
  }
  &-title {
    padding-top: 16px;
    font-size: 24px;
    color: #212121;
  }
  &-pagination {
    padding-top: 16px;
    float: right;
  }
  &-wrapper {
    background: #ffffff;
    border: 1px solid #e7e7e7;
    box-shadow: inset 0 -1px 0 0 #e7e7e7;
    border-radius: 4px;
    padding: 32px 34px;
    margin-top: 38px;
  }
  &-body {
    &-title {
      font-size: 24px;
      color: #212121;
      text-align: center;
    }
    &-time {
      font-size: 16px;
      color: #999999;
      text-align: right;
      padding: 16px 20px;
    }
    &-content {
      white-space: pre-wrap;
      font-size: 16px;
      color: #505050;
      line-height: 28px;
    }
    &-signature {
      font-size: 16px;
      color: #999999;
      padding: 0 20px;
      text-align: right;
      margin-top: 20px;
    }
  }
}
</style>
